var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStayOrGo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480.014 480.014",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "scale(1, -1)",
      transformOrigin: "center"
    }
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.002 480.008c-17.665-.02-31.98-14.335-32-32v-320l-38.4 51.2c-10.604 14.138-30.662 17.004-44.8 6.4s-17.004-30.662-6.4-44.8l96-128c10.604-14.138 30.662-17.004 44.8-6.4 2.426 1.819 4.581 3.974 6.4 6.4l96 128c10.598 14.143 7.724 34.2-6.42 44.797-14.134 10.591-34.177 7.728-44.78-6.397l-38.4-51.2v169.021c35.205-31.501 80.769-48.95 128.01-49.021h64l-51.2-38.4c-14.134-10.61-16.99-30.669-6.38-44.803 10.603-14.125 30.646-16.988 44.78-6.397l128 96c14.138 10.604 17.004 30.661 6.4 44.8-1.819 2.426-3.974 4.581-6.4 6.4l-128 96c-5.525 4.167-12.261 6.415-19.182 6.4-17.673.01-32.008-14.309-32.018-31.982-.006-10.079 4.737-19.571 12.8-25.618l51.2-38.4h-64c-70.659.081-127.919 57.341-128 128v8c-.021 17.668-14.342 31.985-32.01 32zm-24-384c4.418 0 8 3.582 8 8v344c0 8.837 7.163 16 16 16s16-7.163 16-16v-8c0-79.4 64.6-144 144.005-144h88c4.418 0 8 3.582 8 8 0 2.518-1.186 4.889-3.2 6.4l-70.4 52.8c-7.069 5.302-8.502 15.331-3.2 22.4s15.331 8.502 22.4 3.2l128-96c7.069-5.302 8.502-15.331 3.2-22.4-.91-1.213-1.987-2.29-3.2-3.2l-128-96c-7.069-5.302-17.098-3.869-22.4 3.2s-3.869 17.098 3.2 22.4l70.4 52.8c3.535 2.651 4.251 7.665 1.6 11.2-1.51 2.013-3.879 3.198-6.395 3.2h-88c-49.526.082-96.738 20.978-130.1 57.581-2.975 3.266-8.035 3.502-11.301.527-1.664-1.516-2.613-3.663-2.613-5.915v-212.193c0-4.418 3.582-8 8-8 2.518 0 4.889 1.186 6.4 3.2l52.8 70.4c5.302 7.069 15.331 8.502 22.4 3.2s8.502-15.331 3.2-22.4l-96-128c-5.302-7.069-15.331-8.502-22.4-3.2-1.213.91-2.29 1.987-3.2 3.2l-96 128c-5.299 7.072-3.862 17.1 3.21 22.399 7.067 5.296 17.088 3.864 22.39-3.199l52.8-70.4c1.512-2.016 3.884-3.201 6.404-3.2z",
    fill: "current",
    "data-original": "#000000",
    style: {}
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayOrGo);
export default __webpack_public_path__ + "static/media/stay-or-go.bc59e6c98b8505b51fe3e61ec0291e69.svg";
export { ForwardRef as ReactComponent };